class ClosePublicationLinkController {
  constructor() {
    this.init();
  }

  init() {
    this.clickPublicationForm();
  }

  clickPublicationForm() {
    document.querySelector('.page-publications-form__close')?.addEventListener(
      'click',
      function (e) {
        document.querySelector('.page-publications-form__wrapper').remove();
      },
      false
    );
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.ClosePublicationLinkController = new ClosePublicationLinkController();
  }
});
